const env = process.env.NODE_ENV || 'development'

// 政企PK答题后端服务地址（网关前缀 /axj，端口 19091）
const config = {
  development: {
    baseURL: 'http://192.168.11.103:19091/axj'
  },
  production: {
    baseURL: 'https://train.aojuai.com/axj'
  }
}
export default config[env] || config.development
